import { Permission } from '../../../../entities/permissions/types/permission.types'
import { Role } from '../types/roles-page-types'

export const getRoleFormInitialValues = (permissions: Permission[], roleParameters: Role | null) => {
  return {
    name: roleParameters?.name ?? '',
    permissions: permissions.reduce((acc: Record<string, boolean>, v) => {
      acc[v.id] = !!roleParameters?.permissions?.[v.id]

      return acc
    }, {}),
  }
}
